import { PayloadAction } from '@reduxjs/toolkit';

import { AddonData, AddonsState } from 'editor/src/store/editorModules/addons/types';

const setAddonsDataReducer = (state: AddonsState, action: PayloadAction<AddonData | undefined>) => {
  state.data = action.payload;
  state.loadingMore = false;
};

export default setAddonsDataReducer;
